import "core-js/modules/es.array.concat.js";
import { postReq, getReq, patchReq } from './axios';
import { allReferenceParams } from './models';
var BASE_URL = "".concat(apiUrl, "/commission-request");
export var sendRequestCommission = function sendRequestCommission(body) {
  return postReq(BASE_URL, body);
};
export var getCommissionsHistory = function getCommissionsHistory(params) {
  return getReq(BASE_URL, {
    params: allReferenceParams(params)
  });
};
export var changeCommissionRequestStatus = function changeCommissionRequestStatus(id, body) {
  return patchReq("".concat(BASE_URL, "/").concat(id), body);
};